import { render, staticRenderFns } from "./PopupMarketList.vue?vue&type=template&id=3cbb6524"
import script from "./PopupMarketList.vue?vue&type=script&lang=js"
export * from "./PopupMarketList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports